/**
 * MainLayout — Structure principale de l'application
 *
 * Layout en flex : sidebar fixe (300px) + contenu scrollable.
 * Sur mobile, la sidebar est un drawer.
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { Header } from './Header.js';

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: "'Inter', system-ui, sans-serif", background: '#fafafa' }}>
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Zone principale */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />

        {/* Contenu des pages (padding 2rem comme le PHP) */}
        <main style={{ flex: 1, overflowY: 'auto', background: '#fafafa', padding: 'clamp(1rem, 3vw, 2rem)', minWidth: 0 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
